"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.XhrCCInitializer = exports.XhrInitializer = exports.XhrHybridInitializer = exports.XhrInitializationError = void 0;
const web_ui_framework_1 = require("@gruposantander/web-ui-framework");
const web_ui_security_1 = require("@gruposantander/web-ui-security");
const helpers_1 = require("./plugins/helpers");
const plugins_1 = require("./plugins");
const xhr_1 = require("../security/xhr");
const XHR_ERROR = 'XHR initialization error';
class XhrInitializationError extends web_ui_framework_1.InitializerError {
    constructor(message) {
        super(XHR_ERROR, message);
    }
}
exports.XhrInitializationError = XhrInitializationError;
class XhrHybridInitializer extends web_ui_framework_1.Initializer {
    constructor(config, session, authoriser, locale, mobileConnector) {
        super([session, authoriser, locale, mobileConnector]);
        this.launch = async () => {
            try {
                const { bankId, language } = this.config;
                const session = this.session.getInitialized();
                const authoriser = this.authoriser.getInitialized();
                this.locale.getInitialized().setLocale(language);
                const xhrRequestsBlocker = web_ui_framework_1.XhrRequestsBlockerFactory.getNewXHRRequestsBlocker();
                const invalidateCache = helpers_1.XhrPluginsHelpersFactory.getXhrCheckInvalidateCacheHeader(() => this.mobileConnector.getInitialized());
                const plugins = [
                    new web_ui_framework_1.XHRAcceptLanguagePlugin(language),
                    new web_ui_security_1.XHRAuthPlugin(session),
                    new web_ui_framework_1.XHRBankIdPlugin(bankId),
                    new web_ui_security_1.XHRRefreshSessionPlugin(session, xhrRequestsBlocker),
                    new xhr_1.XHRAuthoriserPlugin(authoriser),
                    new plugins_1.XHRDeviceUuidPlugin(web_ui_framework_1.getDeviceUUID),
                    new plugins_1.XHRInvalidateCachePlugin(invalidateCache),
                ];
                const API = new web_ui_framework_1.XHR({
                    plugins,
                });
                return API;
            }
            catch (e) {
                throw new XhrInitializationError(e);
            }
        };
        this.config = config;
        this.session = session;
        this.authoriser = authoriser;
        this.locale = locale;
        this.mobileConnector = mobileConnector;
    }
}
exports.XhrHybridInitializer = XhrHybridInitializer;
class XhrInitializer extends web_ui_framework_1.Initializer {
    constructor(config, session, authoriser, locale) {
        super([session, authoriser, locale]);
        this.launch = async () => {
            try {
                const { bankId, language } = this.config;
                const session = this.session.getInitialized();
                const authoriser = this.authoriser.getInitialized();
                this.locale.getInitialized().setLocale(language);
                const xhrRequestsBlocker = web_ui_framework_1.XhrRequestsBlockerFactory.getNewXHRRequestsBlocker();
                const plugins = [
                    new web_ui_framework_1.XHRAcceptLanguagePlugin(language),
                    new web_ui_security_1.XHRAuthPlugin(session),
                    new web_ui_framework_1.XHRBankIdPlugin(bankId),
                    new web_ui_security_1.XHRRefreshSessionPlugin(session, xhrRequestsBlocker),
                    new xhr_1.XHRAuthoriserPlugin(authoriser),
                    new plugins_1.XHRDeviceUuidPlugin(web_ui_framework_1.getDeviceUUID),
                ];
                const API = new web_ui_framework_1.XHR({
                    plugins,
                });
                return API;
            }
            catch (e) {
                throw new XhrInitializationError(e);
            }
        };
        this.config = config;
        this.session = session;
        this.authoriser = authoriser;
        this.locale = locale;
    }
}
exports.XhrInitializer = XhrInitializer;
class XhrCCInitializer extends web_ui_framework_1.Initializer {
    constructor(config, session, authoriser, locale) {
        super([session, authoriser, locale]);
        this.launch = async () => {
            try {
                const { bankId, language } = this.config;
                const session = this.session.getInitialized();
                const authoriser = this.authoriser.getInitialized();
                this.locale.getInitialized().setLocale(language);
                const xhrRequestsBlocker = web_ui_framework_1.XhrRequestsBlockerFactory.getNewXHRRequestsBlocker();
                const plugins = [
                    new web_ui_framework_1.XHRAcceptLanguagePlugin(language),
                    new web_ui_security_1.XHRAuthPlugin(session),
                    new web_ui_framework_1.XHRBankIdPlugin(bankId),
                    new web_ui_security_1.XHRRefreshSessionPlugin(session, xhrRequestsBlocker),
                    new xhr_1.XHRAuthoriserPlugin(authoriser),
                    new plugins_1.XHRDeviceUuidPlugin(web_ui_framework_1.getDeviceUUID),
                ];
                const API = new web_ui_framework_1.XHR({
                    plugins,
                });
                return API;
            }
            catch (e) {
                throw new XhrInitializationError(e);
            }
        };
        this.config = config;
        this.session = session;
        this.authoriser = authoriser;
        this.locale = locale;
    }
}
exports.XhrCCInitializer = XhrCCInitializer;
//# sourceMappingURL=xhr.initalizer.js.map